import { AccessCodes } from 'app/area/codetable/types-store';
import { CompanyReportItemValidation } from 'app/area/company-reports-administration/form/types-store';
import { RefObject } from 'react';

export interface WithMetroLineProps<SectionType> extends WithInvalidSection<SectionType> {
  configuration: Configuration<SectionType>[];
  initialMode?: ViewMode;
  initialSection?: SectionType;
  forceMode?: ViewMode;
  translation: { [key: string]: string };
  scrollViewUrl: string;
  label?: string;
  hasBigStickyHeader?: boolean;
  validation: CompanyReportItemValidation;
}

export interface WithInvalidSection<SectionType> {
  invalidSection: Configuration<SectionType>;
}

export interface WithCodetableAccess {
  codes: AccessCodes;
}

export interface WithMetroLineWrappedComponentProps<SectionType> {
  getRef: (sectionType: SectionType) => RefObject<HTMLDivElement | null>;
  shouldRenderSection: (currentSection: SectionType | string, sectionType: SectionType) => boolean;
}

export interface MetroLineProps<SectionType> extends WithMetroLineProps<SectionType> {
  activeMode: ViewMode;
  activeSection: SectionType;
  changeViewMode: () => void;
  updateActiveSection: (activeSection: SectionType) => void;
}

export interface Configuration<SectionType> {
  section: SectionType;
  visible: boolean;
  iconUrl: string;
  url: string;
  label: (translation: { [key: string]: string }) => string;
  ref?: RefObject<HTMLDivElement | null>;
  isValid?: boolean;
  hasWarnings?: boolean;
}

export enum ViewMode {
  tabs = 'tabs',
  scroll = 'scroll'
}

export interface TabItemWrapperProps<SectionType> {
  id: number;
  anchorId: string;
  item: Configuration<SectionType>;
  active: boolean;
  valid: boolean;
  warnings: boolean;
  translation: { [key: string]: string };
  itemRef: RefObject<HTMLElement | null>;
  activeMode: ViewMode;
  updateActiveSection: (activeSection: SectionType) => void;
}

export interface MetroLineSectionProps<SectionType> extends WithMetroLineWrappedComponentProps<SectionType> {
  section: SectionType | string;
  sectionType: SectionType;
  hasBigStickyHeader?: boolean;
  children?: React.ReactNode;
}
